<template>
  <div class="page">
    <project-page-header show-steps ref="pageHeader" :id="projectId">
      <template v-slot:actions="{ data }">
        <a-space>
          <template v-if="data.state === 1">
            <a-button class="v-px-sm" icon="arrow-right" type="primary" :loading="saving" @click="handleReivew">下一步，上传项目协议</a-button>
          </template>
          <a-button size="default" class="v-px-sm" type="default" icon="left" @click="$router.push(`/project/main/house/view?id=${data.pid}`)" v-if="data.pid">返回主项目</a-button>
        </a-space>
      </template>
    </project-page-header>
    <div class="v-px-sm">
      <a-tabs type="card" v-model="tab">
        <a-tab-pane key="basic" tab="项目信息">
          <div class="v-px-sm v-py-sm"><basic /></div>
        </a-tab-pane>
        <a-tab-pane key="meeting" tab="评审会议">
          <div class="v-px-sm v-py-sm"><meeting /></div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import ProjectPageHeader from './common/page-header'
import { reviewPrj } from '@/api/project/house'
import Basic from './view/basic'
import Meeting from './view/meeting'

export default {
  name: 'FundedProjectView',
  components: {
    ProjectPageHeader,
    Basic,
    Meeting,
  },
  data() {
    return {
      tab: 'meeting',
      projectId: +this.$route.query.id,
      saving: false,
    }
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
      }
    },
    handleReivew() {
      this.$confirm({
        title: '确认进入下一步？',
        centered: true,
        onOk: () => {
          // 异步关闭
          this.$message.destroy()
          this.saving = true
          return new Promise((resolve, reject) => {
            reviewPrj(this.projectId).then(({ data }) => {
              this.saving = false
              if (data.success) {
                this.$message.success('操作成功')
                this.$router.push(`contract?id=${this.projectId}`)
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => (this.stoping = false))
        },
      })
    },
  },
  created() {
    this.init()
  },
}
</script>
